<template>
  <div
    v-if="notices.length"
    class="container my-6"
  >
    <project-notice-item
      v-for="(notice, index) in notices"
      :key="index"
      :notice="notice"
    />
  </div>
</template>

<script>
export default {
  name: 'ProjectNotices',
  props: {
    notices: {
      type: Array,
      required: false,
      default() {
        return []
      }
    }
  },
}
</script>
